import createIcon from '../../createIcon';

/**
 * @component @name DataThresholding
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xMC42NyA4LjE3TDEyLjY3IDEwLjE3TDE2LjM0IDYuNUwxNy43NSA3LjkxTDEyLjY3IDEzTDEwLjY3IDExTDcuNjcgMTRMNi4yNiAxMi41OUwxMC42NyA4LjE3Wk01IDE2SDYuNzJMNSAxNy43MlYxNlpNNS44NCAxOUw4Ljg0IDE2SDEwLjY3TDcuNjcgMTlINS44NFpNOS44IDE5TDEyLjggMTZIMTQuNDJMMTEuNDIgMTlIOS44Wk0xMy41MyAxOUwxNi41MyAxNkgxOC4xNUwxNS4xNSAxOUgxMy41M1pNMTkgMTlIMTcuMjdMMTkgMTcuMjdWMTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DataThresholding = createIcon('DataThresholding', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM10.67 8.17L12.67 10.17L16.34 6.5L17.75 7.91L12.67 13L10.67 11L7.67 14L6.26 12.59L10.67 8.17ZM5 16H6.72L5 17.72V16ZM5.84 19L8.84 16H10.67L7.67 19H5.84ZM9.8 19L12.8 16H14.42L11.42 19H9.8ZM13.53 19L16.53 16H18.15L15.15 19H13.53ZM19 19H17.27L19 17.27V19Z',
      key: 'x6xq0s',
    },
  ],
]);

export default DataThresholding;
